import { InputRef } from 'antd';
import React, { createContext, useContext, useRef, useState } from 'react';
import LayoutContext from './LayoutContext';

export type UniversalSearchContextType = {
  activeRow?: number;
  setActiveRow: React.Dispatch<React.SetStateAction<null | number>>;
  searchOpenFromTour: boolean;
  setSearchOpenFromTour: React.Dispatch<React.SetStateAction<boolean>>;
  closeSearchFromTourModal: boolean;
  setCloseSearchFromTourModal: React.Dispatch<React.SetStateAction<boolean>>;
  universalSearchRef: React.MutableRefObject<InputRef | null>;
  setSearchOpen: () => void;
  setSearchClose: () => void;
};

const UniversalSearchContext = createContext<UniversalSearchContextType>(null);

export default UniversalSearchContext;

export const UniversalSearchContextProvider: React.FC = ({ children }) => {
  const [activeRow, setActiveRow] = useState(null);
  const [searchOpenFromTour, setSearchOpenFromTour] = useState(false);
  const [closeSearchFromTourModal, setCloseSearchFromTourModal] =
    useState(false);
  const { setBlurBackgroundVisibility, stopOverflow, startOverflow } =
    useContext(LayoutContext);
  const universalSearchRef = useRef<InputRef | null>(null);

  const setSearchOpen = () => {
    universalSearchRef?.current?.focus();
    setBlurBackgroundVisibility(true);
    stopOverflow();
  };

  const setSearchClose = () => {
    setBlurBackgroundVisibility(false);
    startOverflow();
  };

  return (
    <UniversalSearchContext.Provider
      value={{
        activeRow,
        setActiveRow,
        searchOpenFromTour,
        setSearchOpenFromTour,
        closeSearchFromTourModal,
        setCloseSearchFromTourModal,
        universalSearchRef,
        setSearchOpen,
        setSearchClose,
      }}
    >
      {children}
    </UniversalSearchContext.Provider>
  );
};
